import { __ } from "@wordpress/i18n";
import Hint from '../components/Hint/Hint';
import InfoBox from '../components/InfoBox/InfoBox';
import Switch from '../components/Switch/Switch';
import TagInput from '../components/TagInput/TagInput';
import { useMenu } from '../contexts/MenuContext';
import withForm from '../layouts/withForm';
const SecurityInjectionGuard = ({handleChange}) => {  
    const {
        settingData
    } = useMenu();
    const methodList = ['PUT','PATCH','DELETE','HEAD','OPTIONS'];   
    // For data table
    
    // For data table
    return (
        <>
            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Enable URL Guard", "ultimate-security")}</h5>
                            {/* <p className="pl-body text-text">{__("Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam nihil ad consequatur expedita cumque debitis dicta amet velit consectetur eaque.", "ultimate-security")}</p> */}
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/disable based on your requirements.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.url_guard.overview.enable"
                                    checked={settingData?.security?.url_guard?.overview?.enable} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                    valueType="string"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Request Methods", "ultimate-security")}</h5>
                            {/* <p className="pl-body text-text">{__("Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ratione velit sunt fugiat nesciunt iusto consectetur ipsa nobis est eius maxime.", "ultimate-security")}</p> */}
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("Set methods based on your requirements.", "ultimate-security")}/>                                    
                                    <TagInput 
                                        name='security.url_guard.overview.request_methods' 
                                        type='method' 
                                        initialTags={settingData?.security?.url_guard?.overview?.request_methods} 
                                        handleChange={handleChange} 
                                        whitelist={methodList}
                                    />
                                </div>
                                <div className="content-below-with-hint mt-2">                                    
                                    <InfoBox className="small-infobox" title={__( "Warning", "ultimate-security" )} content={__( "Warning: Implementing requests other then HEAD (ex; GET, POST, etc) might lock you out. Delete the \"ultimate_security_options\" -> \"Injection Guard\" -> \"Overview\" -> \"Requests Log\"", "ultimate-security" )} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
           
        </>
    )
}
export default withForm(SecurityInjectionGuard, 'security.url_guard.overview');